import { render, staticRenderFns } from "./ConfirmQuestionModal.vue?vue&type=template&id=4864f77e&"
import script from "./ConfirmQuestionModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmQuestionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports